import { gql } from "@apollo/client";
import apolloClient from "helpers/apolloClient";
import { Plus } from "mdi-material-ui";
import React, { useState } from "react";
import ReadminObjectInput from "readmin_pages/shared/ReadminObjectInput";

export default function ParticipantInput({ onAddParticipant, participants = [] }) {
  const [selectedPerson, setSelectedPerson] = useState(null);

  return (
    <ReadminObjectInput
      label="Add Spectator"
      optionsTypename="Person"
      value={selectedPerson}
      selectedReadminObjects={participants.map((p) => ({ id: p.person_id, __typename: "Person" }))}
      placeholder={
        <>
          <Plus sx={{ fontSize: 16, verticalAlign: "middle", mr: 0.5 }} />
          Add
        </>
      }
      onChange={async (person) => {
        if (!person) return;
        if (participants.some((p) => p.person_id === person.id)) return;

        let name = person.readminName;
        if (!name) {
          const result = await apolloClient.query({
            query: gql`
              query ParticipantInputReadminName($id: ID, $typename: String) {
                readminObject(id: $id, typename: $typename) {
                  id
                  readminName
                }
              }
            `,
            variables: { id: person.id, typename: person.__typename },
          });
          name = result.data?.readminObject?.readminName || "Unknown";
        }

        onAddParticipant({ person_id: person.id, name, role: "spectator" });
        setSelectedPerson(null);
      }}
    />
  );
}
